module.exports = __webpack_public_path__ + "img/2.2afeb14e.png";